import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/ColDocumentedProps";

export default class Col extends React.Component {
    render() {
        return <div className={this.buildClass()}>{this.props.children}</div>;
    }

    static buildGutterClass(position, size) {
        if (size > 1) {
            return ` tq-gutter-${position}-x${size}`;
        } else {
            return ` tq-gutter-${position}`;
        }
    }

    buildClass() {
        let result = "";
        result += this.computeColSizeClass();
        result += this.computeOffsetClass();
        result += this.computeGuttersClass();
        result += this.props.extraClasses ? ` ${this.props.extraClasses}` : "";
        result += this.computeJustification();
        result += this.computeHideClass();
        result += this.computePushClass();
        result += this.computePullClass();
        return result;
    }

    computeGuttersClass() {
        let gutterClassName = "";

        // skip
        if (this.props.skipGutter) {
            gutterClassName += " tq-no-gutter";
        }
        if (this.props.skipGutterLeft) {
            gutterClassName += " tq-no-gutter-left";
        }
        if (this.props.skipGutterRight) {
            gutterClassName += " tq-no-gutter-right";
        }
        if (this.props.gutterAll) {
            gutterClassName += Col.buildGutterClass("all", this.props.gutterAll);
        }
        if (this.props.gutterLeft) {
            gutterClassName += Col.buildGutterClass("left", this.props.gutterLeft);
        }
        if (this.props.gutterRight) {
            gutterClassName += Col.buildGutterClass("right", this.props.gutterRight);
        }
        if (this.props.gutterTop) {
            gutterClassName += Col.buildGutterClass("top", this.props.gutterTop);
        }
        if (this.props.gutterBottom) {
            gutterClassName += Col.buildGutterClass("bottom", this.props.gutterBottom);
        }
        return gutterClassName;
    }

    computeColSizeClass() {
        let result = "";

        // at least one should be defined
        if (!(this.props.sm || this.props.md || this.props.lg)) {
            result += "tq-col-l-12 ";
        }

        if (this.props.sm) {
            result += `tq-col-s-${this.props.sm} `;
        }

        if (this.props.md) {
            result += `tq-col-m-${this.props.md} `;
        }

        if (this.props.lg) {
            result += `tq-col-l-${this.props.lg} `;
        }

        return result;
    }

    computeOffsetClass() {
        let result = "";

        if (this.props.offsetWhenSmall) {
            result += ` tq-col-s-offset-${this.props.offsetWhenSmall}`;
        }
        if (this.props.offsetWhenMedium) {
            result += ` tq-col-m-offset-${this.props.offsetWhenMedium}`;
        }
        if (this.props.offsetWhenLarge) {
            result += ` tq-col-l-offset-${this.props.offsetWhenLarge}`;
        }

        return result;
    }

    computeHideClass() {
        let result = "";

        if (this.props.hideWhenSmall) {
            result += " tq-col-s-hide";
        }
        if (this.props.hideWhenMedium) {
            result += " tq-col-m-hide";
        }
        if (this.props.hideWhenLarge) {
            result += " tq-col-l-hide";
        }

        return result;
    }

    computePushClass() {
        let result = "";

        if (this.props.pushWhenSmall) {
            result += ` tq-col-s-push-${this.props.pushWhenSmall}`;
        }
        if (this.props.pushWhenMedium) {
            result += ` tq-col-m-push-${this.props.pushWhenMedium}`;
        }
        if (this.props.pushWhenLarge) {
            result += ` tq-col-l-push-${this.props.pushWhenLarge}`;
        }

        return result;
    }

    computePullClass() {
        let result = "";

        if (this.props.pullWhenSmall) {
            result += ` tq-col-s-pull-${this.props.pullWhenSmall}`;
        }
        if (this.props.pullWhenMedium) {
            result += ` tq-col-m-pull-${this.props.pullWhenMedium}`;
        }
        if (this.props.pullWhenLarge) {
            result += ` tq-col-l-pull-${this.props.pullWhenLarge}`;
        }

        return result;
    }

    computeJustification() {
        let justifyContentClass = "";
        if (this.props.justifyContent) {
            justifyContentClass = ` tq-text-${this.props.justifyContent}`;
        }
        return justifyContentClass;
    }
}

Col.displayName = "Col";

Col.propTypes = {
    extraClasses: PropTypes.string,
    skipGutter: PropTypes.bool,
    skipGutterLeft: PropTypes.bool,
    skipGutterRight: PropTypes.bool,
    gutterAll: PropTypes.oneOf([1, 2, 3]),
    gutterLeft: PropTypes.oneOf([1, 2, 3]),
    gutterRight: PropTypes.oneOf([1, 2, 3]),
    gutterTop: PropTypes.oneOf([1, 2, 3]),
    gutterBottom: PropTypes.oneOf([1, 2, 3]),
    lg: PropTypes.number,
    md: PropTypes.number,
    sm: PropTypes.number,
    justifyContent: PropTypes.string,
    offsetWhenLarge: PropTypes.number,
    offsetWhenMedium: PropTypes.number,
    offsetWhenSmall: PropTypes.number,
    hideWhenLarge: PropTypes.bool,
    hideWhenMedium: PropTypes.bool,
    hideWhenSmall: PropTypes.bool,
    pushWhenLarge: PropTypes.number,
    pushWhenMedium: PropTypes.number,
    pushWhenSmall: PropTypes.number,
    pullWhenLarge: PropTypes.number,
    pullWhenMedium: PropTypes.number,
    pullWhenSmall: PropTypes.number
};

Col.documentedProps = documentedProps;
